/* eslint-disable prettier/prettier */
/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import React from 'react';
import { ActivityTypeConfig } from '../../types/schedule.types';
import styles from '../../styles/Schedule/ActivityTypeChip.module.css';

interface ActivityTypeChipProps {
	config: ActivityTypeConfig;
	isActive: boolean;
	onToggle: () => void;
}

const ActivityTypeChip: React.FC<ActivityTypeChipProps> = ({
	config,
	isActive,
	onToggle,
}) => {
	return (
		<button
			className={`${styles.chip} ${isActive ? styles.chipActive : ''}`}
			onClick={onToggle}
			style={
				isActive
					? {
							backgroundColor: config.chipBg,
							//   borderColor: config.color,
							borderBottomColor: config.color,
							//   color: config.color,
						}
					: {
							backgroundColor: '#fff',
							borderColor: '#E0E0E0',
							color: '#555',
						}
			}
			aria-pressed={isActive}
		>
			{config.label}
		</button>
	);
};

export default ActivityTypeChip;
